import React from 'react'
import { containsInvalidValue } from './containsInvalidValue'

export const ContactDetailsName = ({ errors, touched, values }) => {
  const { anonymous_acknowledgement } = values

  const isInvalidName = containsInvalidValue(
    ['first_name', 'last_name'],
    errors,
    touched
  )
  const anon = anonymous_acknowledgement[0] === 'Yes'

  return (
    <React.Fragment>
      <h2 className="ds-u-margin-bottom--0">Name</h2>
      {isInvalidName && !anon && (
        <p className="ds-u-color--error ds-u-margin-bottom--0">
          You must provide your name and contact information or check the
          acknowledgement statement below.
        </p>
      )}
    </React.Fragment>
  )
}
